import { render, staticRenderFns } from "./AddAccommodationButton.vue?vue&type=template&id=d2020358&scoped=true"
import script from "./AddAccommodationButton.vue?vue&type=script&lang=js"
export * from "./AddAccommodationButton.vue?vue&type=script&lang=js"
import style0 from "./AddAccommodationButton.vue?vue&type=style&index=0&id=d2020358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2020358",
  null
  
)

export default component.exports